<template>
<div class="error-component error-cant-reach-server card border-warning text-center">
  <div class="card-header bg-warning">
    ข้อมูลไม่ครบ
  </div>
  <div class="card-body">   
    <p class="card-text">ข้อมูลไม่เพียงพอต่อ{{text}} กรุณาตรวจสอบข้อมูลอีกครั้ง</p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'สิ่งที่คุณขอ'
    },
  }
}
</script>

<style lang="scss">
</style>
